import React, { useState } from 'react';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import AudienceHero from '../../components/AudienceHero';
import HowItWorks from '../../components/HowItWorks';
import AssessmentPromo from '../../components/AssessmentPromo';
import SimplifiedPricing from '../../components/SimplifiedPricing';
import MindsetQuizPromo from '../../components/MindsetQuizPromo';
import { LeadMagnetPromo, ATHLETE_PLAYBOOK_CONFIG } from '../../components/LeadMagnetPromo';
import AICoachAthleteSection from '../../components/AICoachAthleteSection';
import FinalCTABanner from '../../components/FinalCTABanner';
import PrivacyPolicy from '../../components/PrivacyPolicy';
import { CALENDLY_URL, LOGO_URL, INSTAGRAM_URL } from '../../lib/siteConfig';

/**
 * /athletes — dedicated landing for athlete-facing pain points + offers.
 * Composes existing homepage components instead of re-authoring copy.
 */
export default function AthletesPage() {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  return (
    <div className="min-h-screen bg-background text-foreground" data-testid="athletes-page">
      <Navbar calendlyLink={CALENDLY_URL} logoUrl={LOGO_URL} />
      <main>
        <AudienceHero
          testIdPrefix="athletes-hero"
          eyebrow="For Athletes"
          headline="Compete with confidence. Perform under pressure."
          subhead="For middle school, high school, and college athletes who refuse to let nerves, doubt, or mental blocks hold them back. Build the same mental skills the pros train — in a system you can run before every game."
          primaryCta={{ href: CALENDLY_URL, label: 'Book a Discovery Call', external: true }}
          secondaryCta={{ href: '/assessment', label: 'Get the Apex Six IDP — $27' }}
        />

        {/* How it works for athletes — 3-step path before pricing / promos */}
        <HowItWorks variant="athlete" />

        <AssessmentPromo />
        <SimplifiedPricing calendlyLink={CALENDLY_URL} />
        <MindsetQuizPromo />
        <LeadMagnetPromo config={ATHLETE_PLAYBOOK_CONFIG} />
        <AICoachAthleteSection />

        <FinalCTABanner
          primaryHref={CALENDLY_URL}
          primaryLabel="Book a Discovery Call"
          secondaryHref="/assessment"
          secondaryLabel="Start the $27 IDP"
        />
      </main>
      <Footer
        calendlyLink={CALENDLY_URL}
        instagramLink={INSTAGRAM_URL}
        logoUrl={LOGO_URL}
        onPrivacyClick={() => setPrivacyOpen(true)}
      />
      <PrivacyPolicy open={privacyOpen} onClose={() => setPrivacyOpen(false)} />
    </div>
  );
}
